import { Obj } from "../internal";
import { Axis } from "./internal";
/**
 * LRHandler
 * @class LRHandler
 * @constructor
 */
export class LRHandler extends Obj {
    /**
     * Linear Referencing Handler
     * @method constructor
     */
    constructor() {
        super();
        this.axisarray = [];
        this._active_navigation_axis = null;
        this._active_measurement_axis = null;
        this.cbfnavigationaxischanged = null;
        this.cbfmeasurementaxischanged = null;
        this.reloadingAxis = false;
    }
    /**
     * Creates an Axis Object
     * @method createAxis
     * @param {Object} featurecollection
     * @param {string=} nominallengthattribute
     * @param {string=} offsetattribute
     * @param {string[]} idattributearray
     * @returns {Axis}
     */
    createAxis(featurecollection, nominallengthattribute, offsetattribute, idattributearray, axisname) {
        const axis = new Axis(featurecollection, nominallengthattribute, offsetattribute, idattributearray, axisname);
        this.axisarray.push(axis);
        return axis;
    }
    /**
     * Removes the Axis from the lrHandler and destroys it and its connected featureCollection.
     * @method removeAxis
     * @param {Axis} axis
     */
    removeAxis(axis) {
        let index = -1;
        for (let i = 0; i < this.axisarray.length; i++) {
            if (this.axisarray[i] == axis) {
                this.axisarray[i].destroy();
                index = i;
            }
        }
        if (index >= 0)
            this.axisarray.splice(index, 1);
        if (axis == this._active_navigation_axis) {
            this._active_navigation_axis = null;
            if (this.cbfnavigationaxischanged != null) {
                this.cbfnavigationaxischanged.call(this, null);
            }
        }
        if (axis == this._active_measurement_axis) {
            this._active_measurement_axis = null;
            if (this.cbfmeasurementaxischanged != null) {
                this.cbfmeasurementaxischanged.call(this, null);
            }
        }
    }
    /**
     * Set the active navigation axis
     * @method setActiveNavigationAxis
     * @param {Axis | null} axis
     */
    setActiveNavigationAxis(axis) {
        if (axis != this._active_navigation_axis) {
            this._active_navigation_axis = axis;
            if (this.cbfnavigationaxischanged != null) {
                this.cbfnavigationaxischanged.call(this, this._active_navigation_axis);
            }
        }
    }
    /**
     * Set the active measurement axis
     * @method setActiveMeasurementAxis
     * @param {Axis | null} axis
     */
    setActiveMeasurementAxis(axis) {
        if (axis != this._active_measurement_axis) {
            this._active_measurement_axis = axis;
            if (this.cbfmeasurementaxischanged != null) {
                this.cbfmeasurementaxischanged.call(this, this._active_measurement_axis);
            }
        }
    }
    /**
     * Get the active navigation axis
     * @method getActiveNavigationeAxis
     * @return {Axis}
     */
    getActiveNavigationAxis() {
        return this._active_navigation_axis;
    }
    /**
     * Get the active measurement axis
     * @method getActiveMeasurementAxis
     * @return {Axis}
     */
    getActiveMeasurementAxis() {
        return this._active_measurement_axis;
    }
    /**
     * Sets the OnNavigationAxisChanged-Callback-Function
     * @method setOnNavigationAxisChanged
     * @param {Function} f
     */
    setOnNavigationAxisChanged(f) {
        this.cbfnavigationaxischanged = f;
    }
    /**
     * Sets the OnMeasurementAxisChanged-Callback-Function
     * @method setOnMeasurementAxisChanged
     * @param {Function} f
     */
    setOnMeasurementAxisChanged(f) {
        this.cbfmeasurementaxischanged = f;
    }
}
//# sourceMappingURL=lrhandler.js.map